import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import StatusEditDto from 'app/admin/status/dto/StatusEditDto';
import nBossConnection from 'modules/base/service/nBossConnection';
import NamedDto from 'modules/base/dto/NamedDto';
import StatusTableDto from 'app/admin/status/dto/StatusTableDto';
import GenericTableDto from 'modules/base/dto/table/GenericTableDto';

class StatusEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'statusControl';
	}

	/**
	 * @return {Promise<GenericTableDto<StatusTableDto>>}
	 */
	getList() {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, StatusTableDto)))
				.catch(reject);
		});
	}
}

export default new StatusEditService();
